<!-- error alert -->
@if (saveError()) {
  <div class="w-full mb-4">
    <modus-alert class="w-full" [message]="translations.saveError.text" type="error"></modus-alert>
  </div>
}

<div class="flex flex-col">
  <!-- tags -->
  <div class="flex justify-start flex-wrap">
    @for (tag of selectedTags(); track tag) {
      <modus-chip
        class="m-1"
        show-close
        data-cy="single-selected-tag-chip"
        [value]="tag"
        (closeClick)="remove(tag)"
        [disabled]="disableEdit()"
      >
      </modus-chip>
    }
  </div>

  <!-- autocomplete-->

  <modus-autocomplete-input
    #autocomplete
    data-cy="single-selected-tags-input"
    [placeholder]="translations.tagInput.placeholder.text"
    [modus-tooltip]="translations.tagInput.placeholder.text"
    [clearable]="true"
    [errorText]="tagSelectorError()"
    [options]="tagOptionList"
    [formControl]="tagSelector"
    (optionSelected)="selected($event)"
  >
  </modus-autocomplete-input>
  <modus-option-list
    #tagOptionList="modusOptionList"
    [noResultsFoundText]="translations.optionList.noResultsFound.text"
    [noResultsFoundSubtext]="translations.optionList.noResultsFoundHint.text"
  >
    @for (tag of filteredTags(); track tag) {
      <modus-option [value]="tag">{{ tag }}</modus-option>
    }
  </modus-option-list>
</div>
